/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FilterDownloadData
 */
export interface FilterDownloadData {
    /**
     * 
     * @type {Date}
     * @memberof FilterDownloadData
     */
    dateFrom?: Date;
    /**
     * 
     * @type {Date}
     * @memberof FilterDownloadData
     */
    dateTo?: Date;
    /**
     * 
     * @type {string}
     * @memberof FilterDownloadData
     */
    companyId?: string;
    /**
     * 
     * @type {string}
     * @memberof FilterDownloadData
     */
    examinedId?: string;
    /**
     * 
     * @type {string}
     * @memberof FilterDownloadData
     */
    healthcareFacilityId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FilterDownloadData
     */
    judgments?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FilterDownloadData
     */
    cards?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FilterDownloadData
     */
    consultations?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FilterDownloadData
     */
    attachments?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FilterDownloadData
     */
    psychologistUId?: string;
    /**
     * 
     * @type {string}
     * @memberof FilterDownloadData
     */
    registerId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof FilterDownloadData
     */
    articlesIds?: Array<string>;
}

/**
 * Check if a given object implements the FilterDownloadData interface.
 */
export function instanceOfFilterDownloadData(value: object): value is FilterDownloadData {
    return true;
}

export function FilterDownloadDataFromJSON(json: any): FilterDownloadData {
    return FilterDownloadDataFromJSONTyped(json, false);
}

export function FilterDownloadDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): FilterDownloadData {
    if (json == null) {
        return json;
    }
    return {
        
        'dateFrom': json['dateFrom'] == null ? undefined : (new Date(json['dateFrom'])),
        'dateTo': json['dateTo'] == null ? undefined : (new Date(json['dateTo'])),
        'companyId': json['companyId'] == null ? undefined : json['companyId'],
        'examinedId': json['examinedId'] == null ? undefined : json['examinedId'],
        'healthcareFacilityId': json['healthcareFacilityId'] == null ? undefined : json['healthcareFacilityId'],
        'judgments': json['judgments'] == null ? undefined : json['judgments'],
        'cards': json['cards'] == null ? undefined : json['cards'],
        'consultations': json['consultations'] == null ? undefined : json['consultations'],
        'attachments': json['attachments'] == null ? undefined : json['attachments'],
        'psychologistUId': json['psychologistUId'] == null ? undefined : json['psychologistUId'],
        'registerId': json['registerId'] == null ? undefined : json['registerId'],
        'articlesIds': json['articlesIds'] == null ? undefined : json['articlesIds'],
    };
}

export function FilterDownloadDataToJSON(value?: FilterDownloadData | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'dateFrom': value['dateFrom'] == null ? undefined : ((value['dateFrom']).toISOString()),
        'dateTo': value['dateTo'] == null ? undefined : ((value['dateTo']).toISOString()),
        'companyId': value['companyId'],
        'examinedId': value['examinedId'],
        'healthcareFacilityId': value['healthcareFacilityId'],
        'judgments': value['judgments'],
        'cards': value['cards'],
        'consultations': value['consultations'],
        'attachments': value['attachments'],
        'psychologistUId': value['psychologistUId'],
        'registerId': value['registerId'],
        'articlesIds': value['articlesIds'],
    };
}

